<div class="post">
  <div class="image">
    <img [src]="imageUrl" />
  </div>
  <div class="text">
    <div class="content">
      <div class="title">{{ title }}</div>
      <div class="desc">
        <!-- La nostra vocazione missionaria nasce dall'ascolto dello Spirito Santo,
      che chiama e invia operai nella Sua messe. Come nella chiesa di Antiochia,
      riconosciamo e sosteniamo coloro che sono chiamati a portare il messaggio
      di salvezza, sia localmente che oltre i confini, confidando nella guida
      divina e nell'intercessione della comunità. -->
        {{ description }}
      </div>
    </div>
    <div class="cta">
      <app-cta [link]="link" [text]="btnText"></app-cta>
    </div>
  </div>
</div>
